<template>
  <div
    class="min-h-screen"
  >
    <div class="z-30 relative">
      <MainHeader />
      <MainMenuTitle />
      <MainFooter />
    </div>
    <Background :adapt="w" :colour="randomColour" class="z-0" stripes=true />
  </div>
</template>

<script>
// @ is an alias to /src
import Background from "@/components/bg/Background.vue"
import MainHeader from "@/components/header/MainHeader.vue"
import MainFooter from "@/components/footer/MainFooter.vue"
import MainMenuTitle from "@/components/content/title/MainMenuTitle.vue"

export default {
  name: 'MainMenu',
  components: {
   Background,
   MainHeader,
   MainFooter,
   MainMenuTitle
  },
  data() {
    return {
      randomColour: { bg: "herocream", img: require('@/assets/img/SVG/BGvanilla.svg') },
      w: "absolute"
    }
  },
  created() {
    window.addEventListener("resize", this.WindowW);
  },
  destroyed() {
    window.removeEventListener("resize", this.WindowW);
  },
  mounted() {
    this.WindowW()
  },
  methods: {
    WindowW() {
      this.w = "absolute"
      var width = window.innerWidth;
      var height = window.innerHeight;
      if(height < 696 && width > 768) {
        this.w = "relative"
      }
    }
  }
}
</script>
